import MainSettings from './MainSettings';

export default MainSettings;
